import i18n from 'i18next';
import Backend from 'i18next-chained-backend';
import HttpApi from 'i18next-http-backend';
import LocalStorageBackend from 'i18next-localstorage-backend';
import { initReactI18next } from 'react-i18next';
import moment from 'moment';
import 'moment/locale/el';
import 'moment/locale/cy';
import 'moment/locale/pt';
import 'moment/locale/en-ie';
import { COUNTRY_CONFIG } from 'Douleutaras/constants/localization';
import { useLocalization } from 'Douleutaras/hooks/localization';
import { FooterState } from 'Douleutaras/types';

const { countryCode, currentLanguage: lng } = useLocalization();

if (i18n.isInitialized) {
  // On the server, i18nServer.ts has already initialized i18n with useSuspense: false.
  // Calling init() again would override that setting and cause useTranslation() to suspend.
  // Skip initialization entirely — the server-side config takes precedence.
} else {
i18n
  .use(initReactI18next)
  .use(Backend)
  .init({
    debug: Boolean(process.env.I18N_DEBUG_ENABLED) || false,
    supportedLngs: [
      ...COUNTRY_CONFIG.LANGUAGES_SUPPORTED[countryCode].map(lang => lang.toLowerCase())
    ],
    backend: {
      backends: [
        LocalStorageBackend,  // primary backend
        HttpApi               // fallback backend
      ],
      backendOptions: [{
        prefix: 'i18next_res_1_',
        expirationTime: 60 * 60 * 1000
      }, {
        loadPath: `${COUNTRY_CONFIG.API_URL[countryCode]}jsi18n/{{lng}}/json/djangojs/?format=json`,
        // Transform data to match our API format
        parse(jsonData, language): Array<FooterState> {
          const rawData = JSON.parse(jsonData);

          // Find the key using lowerCase
          const langKey = Object.keys(rawData)
            .find(key => key.toLowerCase() === language.toLowerCase());

          // Set locale for moment
          moment.locale(language);

          return rawData[langKey];
        }
      }]
    },
    pluralSeparator: '.',
    keySeparator: false, // Disable key separator
    nsSeparator: false, // Disable namespace separator
    lng,
    lowerCaseLng: true,
    interpolation: {
      // react is already safe from xss
      escapeValue: false
    },
    react: {
      transEmptyNodeValue: '', // what to return for empty Trans
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i'],
      transWrapTextNodes: '',
      // No <Suspense> boundary exists client-side, so suspending here crashes the root (REACT-6ZD)
      useSuspense: false
    }
  });
}

export default i18n;
